import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './DiefInfo.module.scss';

export default function DiefInfo() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const acessarSistema = () => {
    globalThis.location.href = `${globalThis.location.origin}/dief`;
  };

  return (
    <div className={styles.page}>
      <div className={styles.topBar}>
        <button
          className={styles.back}
          onClick={() => navigate('/')}
          type='button'
        >
          <i className='fas fa-arrow-left' aria-hidden='true' /> Voltar
        </button>
      </div>

      <div className={styles.hero}>
        <div className={styles.iconWrap}>
          <i className='fas fa-file-alt' aria-hidden='true' />
        </div>
        <div className={styles.heroText}>
          <h1 className={styles.title}>DIEF-CFEM</h1>
          <p className={styles.subtitle}>
            Declaração de Informações Econômico-Financeiras
          </p>
        </div>
      </div>

      <div className={styles.content}>
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>O que é?</h2>
          <p className={styles.text}>
            A DIEF-CFEM é a declaração mensal obrigatória pela qual o
            empreendedor informa os dados econômicos e financeiros que
            fundamentam o cálculo da Compensação Financeira pela Exploração
            Mineral (CFEM). Por meio dela, são registradas as receitas de vendas
            dos recursos minerais extraídos, servindo de base para a apuração do
            valor devido.
          </p>
        </section>

        <section className={`${styles.section} ${styles.highlightSection}`}>
          <div className={styles.highlightIcon}>
            <i className='fas fa-calendar-alt' aria-hidden='true' />
          </div>
          <div>
            <h2 className={styles.sectionTitle}>Prazo de entrega</h2>
            <p className={styles.text}>
              A declaração deve ser gerada até o{' '}
              <strong>26º dia do mês subsequente</strong> ao período de
              referência. Declarações fora do prazo podem estar sujeitas a
              penalidades previstas na legislação vigente.
            </p>
          </div>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Como funciona?</h2>
          <ul className={styles.list}>
            <li>
              Acesse o sistema DIEF-CFEM e faça login com suas credenciais.
            </li>
            <li>
              Informe as receitas de venda dos recursos minerais do mês de
              referência.
            </li>
            <li>
              O sistema calculará automaticamente o valor da CFEM a recolher.
            </li>
            <li>Gere e envie a declaração até o prazo estabelecido.</li>
          </ul>
        </section>

        <div className={styles.ctaWrap}>
          <button
            className={styles.ctaBtn}
            onClick={acessarSistema}
            type='button'
          >
            Acessar DIEF-CFEM{' '}
            <i className='fas fa-external-link-alt' aria-hidden='true' />
          </button>
        </div>
      </div>
    </div>
  );
}
